import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { parseEventsForCalendar } from '../../ProjectDetail/Calendar/Calendar';
import CalendarDetailToolbar from '../../PortfolioDetail/CalendarDetail/CalendarDetailToolbar/CalendarDetailToolbar';
import { getHolidays, postHoliday } from '../../../api/contentManager';
import CustomEvent from '../../ProjectDetail/Calendar/CustomCalendar/CustomEvent/CustomEvent';
import { EventType } from '../../../models/EventType';
import './Holidays.scss';
import { HolidayEventDetail } from '../../ProjectDetail/Calendar/EventDetailInfo/HolidayDetail/HolidayEventDetail';
import BaseModal from '../../Util/Modals/BaseModal';
import { overflowYModalStyles } from '../../Util/Modals/Styles';
import { loaderCustomStyles } from '../../Util/ContentManager/ContentManager';
import ContentManagerLoader from '../ContentManagerLoader/ContentManagerLoader';
import { APPLIED_MODIFY_EVENT } from '../../ProjectDetail/Calendar/EventDetailInfo/HolidayDetail/HolidayEventConstants';

const localizer = momentLocalizer(moment);

export const Holidays = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dateSelected, setDateSelected] = useState(null);
  const [holidays, setHolidays] = useState<any[]>([]);
  const [isOpenCreateHoliday, setIsOpenCreateHoliday] = useState(false);
  const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());

  const { t } = useTranslation();

  const fetchHolidays = async () => {
    const response = await getHolidays();
    setHolidays(response.map(holiday => (
      {
        ...holiday,
        date: holiday.dateHoliday,
        eventType: EventType.Holiday,
        title: holiday.name,
        projectCode: t('holiday')
      })));
  };

  const handleCustomEventClose = useCallback((e) => {
    fetchHolidays();
  }, []);

  useEffect(() => {
    window.addEventListener(APPLIED_MODIFY_EVENT, handleCustomEventClose);
    return () => {
      window.removeEventListener(APPLIED_MODIFY_EVENT, handleCustomEventClose);
    };
  }, [handleCustomEventClose]);

  useEffect(() => {
    setIsLoading(true);
    fetchHolidays().finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (!isOpenCreateHoliday) {
      setDateSelected(null);
    }
  }, [isOpenCreateHoliday])

  const handleCreateHoliday = (data) => {
    const createHoliday = async (data) => {
      postHoliday(data).then(() => {
        fetchHolidays();
      });
    }

    createHoliday(data);
    setIsOpenCreateHoliday(false);
  }

  return (
    <div>
      <h1 className="content-manager__title with-margin">{t('holidays_title')}</h1>
      {
        isLoading ? (
          <div className='holidays-loader'>
            <ContentManagerLoader styles={loaderCustomStyles} />
          </div>
        )
          : (
            <>
              <div className="calendar-detail-container">
                <div className="left-container">
                  {
                    <Calendar
                      localizer={localizer}
                      startAccessor={'start'}
                      endAccessor={'end'}
                      events={parseEventsForCalendar(holidays)}
                      defaultView="month"
                      views={['month']}
                      formats={{
                        weekdayFormat: date => localizer.format(date, 'ddd').substr(0, 3),
                      }}
                      components={{ toolbar: CalendarDetailToolbar, event: CustomEvent }}

                      defaultDate={new Date()}
                      onNavigate={(date) => { setCurrentYear(date.getFullYear()) }}
                      onSelectSlot={(slotInfo) => { setDateSelected(slotInfo.start); setIsOpenCreateHoliday(true); }}
                      selectable
                    />
                  }
                </div>
                <div className='right-container'>
                  <strong className='holidays-title'>{t('holidays_list')} {currentYear}</strong>
                  <br></br>
                  <br></br>
                  <div className='holidays-list'>
                    {holidays
                      .filter(holiday => new Date(holiday.date).getFullYear() === currentYear)
                      .sort((holidayEntry, comparisonHoliday) => new Date(holidayEntry.date).getTime() - new Date(comparisonHoliday.date).getTime())
                      .map((holiday, index) => (
                        <div key={index} className='holiday-item'>
                          <strong>{moment(holiday.date).format('DD MMMM')}: </strong>
                          <span>{holiday.name}</span>
                        </div>
                      ))}
                  </div>
                  <br></br>
                  <section className='holidays-footer'>
                    <button className='btn btn-primary' onClick={() => setIsOpenCreateHoliday(true)}>
                      {t('create_holiday')}
                    </button>
                  </section>
                </div>
              </div>
              <BaseModal
                className='holidays-create-modal'
                isOpen={isOpenCreateHoliday}
                onRequestClose={() => setIsOpenCreateHoliday(false)}
                style={overflowYModalStyles}
              >
                <HolidayEventDetail
                  isCreateMode={true}
                  eventData={{ dateHoliday: dateSelected }}
                  onSave={handleCreateHoliday}
                  closeModal={() => setIsOpenCreateHoliday(false)}
                />
              </BaseModal>
            </>
          )
      }
    </div>
  )
}
